// src/components/Admin/VirtualScenes/SceneForm/MultiStepForm.js
import React, { useState, useRef } from "react"; // <--- Importamos useRef
import { Step } from "semantic-ui-react";
import { Steps as AntSteps } from "antd";
import { useTranslation } from "react-i18next";
import { initialValuesZero } from "./StepZero.form";
import { initialValuesOne } from "./StepOne.form";
import { StepZero } from "./StepZero";
import { StepOne } from "./StepOne";
import { VirtualScenes } from "../../../../api"; // <--- Importamos API
import { useAuth } from "../../../../hooks"; // <--- Importamos Auth
import { NEW_EDUCAMAKER } from "../../../../ui/featureFlags";
import sx from "./SceneFormNew.module.scss";
import "./MultiStepForm.scss";

const virtualSceneController = new VirtualScenes();

export function MultiStepForm({ isUpdateMode, scene, onReload, onClose }) {
  const { accessToken } = useAuth();
  const { t } = useTranslation("scenes");

  // Combinamos valores iniciales
  const mergedInitialValues = {
    ...initialValuesZero(scene),
    ...initialValuesOne(scene),
  };

  const [formData, setFormData] = useState(mergedInitialValues);
  const [step, setStep] = useState(1);

  // useRef para mantener el ID de la escena creada sin provocar re-renders
  // y para saber si el proceso finalizó correctamente.
  const newSceneIdRef = useRef(null);
  const isFinishedRef = useRef(false);

  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);

  const updateFormData = (newData) =>
    setFormData((prev) => ({ ...prev, ...newData }));

  // --- LÓGICA DE CIERRE SEGURO ---
  const handleSafeClose = async () => {
    // Si estamos creando (NO update), tenemos un ID generado y NO hemos terminado:
    if (!isUpdateMode && newSceneIdRef.current && !isFinishedRef.current) {
      try {
        console.log(
          "Cierre incompleto detectado. Borrando escena fantasma:",
          newSceneIdRef.current,
        );
        await virtualSceneController.deleteVirtualScene(
          accessToken,
          newSceneIdRef.current,
        );
        // Limpiamos localStorage por si acaso
        localStorage.removeItem("idScene");
      } catch (error) {
        console.error("Error al limpiar la escena incompleta:", error);
      }
    }

    // Ejecutamos el cierre normal del modal
    onClose();
  };

  // Callback que recibirá el ID desde StepZero
  const handleSceneCreated = (id) => {
    newSceneIdRef.current = id;
  };

  // Callback que recibirá el OK desde StepOne
  const handleSuccess = () => {
    isFinishedRef.current = true;
    onReload();
    onClose(); // Aquí cerramos directamente porque es éxito
  };

  return (
    <div>
      {NEW_EDUCAMAKER ? (
        <AntSteps
          className={sx.steps}
          current={step - 1}
          items={[
            { title: t("form.step0Title") },
            { title: t("form.step1Title") },
          ]}
        />
      ) : (
        <div className="step-group-container">
          <Step.Group ordered>
            <Step active={step === 1} completed={step > 1}>
              <Step.Content>
                <Step.Title>{t("form.step0Title")}</Step.Title>
              </Step.Content>
            </Step>
            <Step active={step === 2} completed={step > 2}>
              <Step.Content>
                <Step.Title>{t("form.step1Title")}</Step.Title>
              </Step.Content>
            </Step>
          </Step.Group>
        </div>
      )}

      {step === 1 && (
        <StepZero
          formData={formData}
          updateFormData={updateFormData}
          nextStep={nextStep}
          isUpdateMode={isUpdateMode}
          scene={scene}
          // Pasamos el notificador de creación
          onSceneCreated={handleSceneCreated}
        />
      )}
      {step === 2 && (
        <StepOne
          formData={formData}
          updateFormData={updateFormData}
          prevStep={prevStep}
          isUpdateMode={isUpdateMode}
          scene={scene}
          // Pasamos nuestros manejadores personalizados
          onSuccess={handleSuccess}
          onClose={handleSafeClose} // Si cancelan en el paso 2, borramos
        />
      )}
    </div>
  );
}
